




















import {Component, Prop, Vue} from "vue-property-decorator";
import EForm from "@/components/datatable/EForm.vue";
import TextField from "@/components/inputs/TextField.vue";
import SeoEntity from "@/entity/SeoEntity";
import ImageUpload from "@/components/inputs/ImageUpload.vue";

@Component({
    components:{
        ImageUpload,
        EForm,TextField
    }
})
export default class SeoForm extends Vue {
    @Prop({default:new SeoEntity()}) data!:SeoEntity;
    success(){
        this.$emit('success');
    }
    action(){
        if(this.data.seo_id)
            return "seo/"+this.data.seo_id;
        return "seo";
    }
}
